// extracted by mini-css-extract-plugin
export default {"loader_container":"loader_loader_container__1YRcp","loader":"loader_loader__M-FUL","l8-0":"loader_l8-0__sPomh","l8-1":"loader_l8-1__oxH9O"};